import { Injectable } from '@angular/core';
import { StoreConfig } from '@datorama/akita';
import { JobStore } from '@y42/job';
import { ExportTriggerJobState } from './export-trigger-job.model';

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'export-trigger-job', idKey: 'request_id' })
export class ExportTriggerJobStore extends JobStore<ExportTriggerJobState> {
  constructor() {
    super();
  }
}
